import React from 'react';
import Type from 'prop-types';
import { noop } from 'lodash';
import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText } from "@mui/material";
import { MoreVert as MoreVertIcon } from "@mui/icons-material";
import { useTranslation } from 'hooks';

const OverflowMenu = (props) => {
  const { actions, onOpen, anchorEl, onActionSelected, onClose, ...other } = props;
  const { t } = useTranslation();
  const handleActionSelected = (actionId) => () => {
    onActionSelected(actionId);
    onClose();
  };

  const isMenuOpen = Boolean(anchorEl);

  return (
    <>
      <IconButton
        edge="end"
        color="inherit"
        aria-label={t('more')}
        aria-controls="overflow-menu"
        aria-haspopup="true"
        onClick={onOpen}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu id="overflow-menu" anchorEl={anchorEl} open={isMenuOpen} {...other} onClose={onClose}>
        {actions.map((action) => {
          const IconAction = action.icon;

          return (
            <MenuItem
              onClick={handleActionSelected(action.id)}
              key={action.id}
              data-testid={action.dataTestId}
            >
              {IconAction && (
                <ListItemIcon>
                  <IconAction />
                </ListItemIcon>
              )}
              <ListItemText>{action.title}</ListItemText>
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
};

OverflowMenu.propTypes = {
  actions: Type.arrayOf(
    Type.shape({
      id: Type.string.isRequired,
      title: Type.string.isRequired,
      show: Type.oneOf(['always', 'never']).isRequired,
      icon: Type.elementType,
      dataTestId: Type.string,
    }),
  ).isRequired,
  anchorEl: Type.instanceOf(Element),
  onActionSelected: Type.func,
  onOpen: Type.func,
  onClose: Type.func,
  anchorOrigin: Type.shape({
    horizontal: Type.oneOfType([Type.number, Type.oneOf(['left', 'center', 'right'])]),
    vertical: Type.oneOfType([Type.number, Type.oneOf(['top', 'center', 'bottom'])]),
  }),
  transformOrigin: Type.shape({
    horizontal: Type.oneOfType([Type.number, Type.oneOf(['left', 'center', 'right'])]),
    vertical: Type.oneOfType([Type.number, Type.oneOf(['top', 'center', 'bottom'])]),
  }),
  keepMounted: Type.bool,
};

OverflowMenu.defaultProps = {
  anchorEl: null,
  keepMounted: true,
  transformOrigin: {
    vertical: 'top',
    horizontal: 'right',
  },
  anchorOrigin: {
    vertical: 'top',
    horizontal: 'right',
  },
  onActionSelected: noop,
  onOpen: noop,
  onClose: noop,
};

export default OverflowMenu;
